<template>
  <b-modal
    v-model="showModal"
    :title="matchTitle"
    centered
    size="md"
    ok-title="Confirm Match"
    cancel-title="Cancel"
    @show="resetModal"
    @hide="handleHide"
    @ok="submitNoMatch"
    @cancel="handleCancel">
    <b-form>
      <b-form-group 
        label="Message:"
        description="This message will be delivered to the uploader"
      >
        <b-form-textarea
          v-validate="'required'"
          id="noMatchMessage"
          v-model="form.matchMessage"
          name="message"
          rows="3"
          max-rows="10"          
          @input="setMessage"
        ></b-form-textarea>
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false
    },
    bioreqTitle: {
      type: String,
      required: false,
      default: ''
    },
    bioreqDocument: {
      type: Object,
      required: true,
      default: null
    }
  },
  data() {
    return {
      form: {
        matchMessage: ''
      },
      modalIsVisible: false
    }
  },
  computed: {
    ...mapState('bioreq/forms/store', [
      'apiErrors',
      'fields',
      'success',
      'saving'
    ]),
    showModal: {
      get () {
        return this.visible
      },
      set (newValue) {
        this.modalIsVisible = newValue
      }
    },
    matchTitle () {
      return `Confirm Match - ${this.bioreqDocument.title}`
    }
  },
  methods: {
    ...mapActions({
      matchBioreq: 'bioreq/match'
    }),
    submitNoMatch (evt) {
      evt.preventDefault()
      this.$store.dispatch('bioreq/match', this.bioreqDocument.id).then(() => {
        this.$emit('hide-match-modal')
      })
    },
    setMessage (event) {
      this.$store.commit('bioreq/forms/match/setField', {
        field: 'message',
        value: event
      })
    },
    resetModal () {
      this.form.matchMessage = ''
    },
    handleCancel () {
      this.$emit('hide-match-modal')
    },
    handleHide () {
      this.$emit('hide-match-modal')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/admin/bioreq/matchModal.vue